import { connectInternalApi } from 'common/api'

type UMVUsageResponse = {
  umv_used: number
  umv_limit: number
  umv_valid: boolean
}

type UMVUsage = {
  umvUsed: number
  umvLimit: number
  umvValid: boolean
}

const mapUMVUsageResponseToUMVUsage = (data: UMVUsageResponse): UMVUsage => ({
  umvUsed: data.umv_used,
  umvLimit: data.umv_limit,
  umvValid: data.umv_valid,
})

export const getUMVUsage = async (accountId: string): Promise<UMVUsage> => {
  const response = await connectInternalApi.get<UMVUsageResponse>(
    `v1/reporting/account/${accountId}/umv`
  )

  return mapUMVUsageResponseToUMVUsage(response.data)
}
